
import React, { useState, Fragment, useEffect } from 'react';
import { Container, Row, Col, Form, InputGroup, Alert, Button, Image, Spinner } from 'react-bootstrap';
import apiEndPoint from 'utils/apiEndPoint';
import { failedMessage } from 'utils/httpClient';
import { successMessage } from 'utils/httpClient';
import { apiCall } from 'utils/httpClient';
import { loadFromLocalStorage } from 'utils/LocalStorageUtils';
import { isEmpty } from 'utils/utils';
import useRazorpay from "react-razorpay";
import { useNavigate } from 'react-router-dom';
import OrderConfirmation from 'pages/orderconfirmation';

function RenewSubscription({ handleCloseRenew, subscriptionDetail, setSubscriptionDetail, handleShowConfirmation, setOrderCompleateData }) {
  const [Razorpay] = useRazorpay();
  const navigate = useNavigate();
  // const [domain, setDomain] = useState('');
  const [isPremium, setIsPremium] = useState(true); // Assuming premium domain selected
  // const [aiMarketing, setAiMarketing] = useState(true);
  const [userData, setUserData] = useState('');
  // const [formDetail, setFormDetail] = useState({});
  const [paymentDetail, setPaymentDetail] = useState({})
  const [isloading, setIsloading] = useState(false);
  const [isloadingPage, setIsloadingPage] = useState(false);
  const [orderDetail, setOrderDetail] = useState(null);
  const [selectedDomain, setselectedDomain] = useState(null);
  const [pageShow, setPageShow] = useState(0);

  const [languageData, setLanguageData] = useState(null);
  const selectLang = loadFromLocalStorage("SELECTLANGUAGE");
  useEffect(() => {
    setLanguageData(selectLang?.language)
  }, [selectLang])


  useEffect(() => {
    const authData = loadFromLocalStorage("AUTH_DATA");
    if (authData) {
      setUserData(authData.userDetail)
    }
  }, []);

  const basePrice = 10;
  const premiumCharge = 1000;
  const aiMarketingPrice = 5;

  const calculateTotal = () => {

    const basPrice = basePrice * 365;
    const domain_price = subscriptionDetail?.domain_price > 750 ? subscriptionDetail?.domain_price : 0;
    const aiPrice = Boolean(subscriptionDetail?.aimarketing_status) ? aiMarketingPrice * 365 : 0;

    const countNum = (Number(basPrice) + Number(domain_price) + Number(aiPrice));
    return parseFloat(countNum.toFixed(2));

    // return basePrice * 365 + (isPremium ? premiumCharge : 0) + (aiMarketing ? aiMarketingPrice * 365 : 0);
  };
  const handleInputValue = (name, value) => {
    let array = subscriptionDetail?.billing_details
    const arr = { ...array, [name]: value }
    setSubscriptionDetail({ ...subscriptionDetail, billing_details: arr })
  };

  async function orderCompleate(responce) {
    if (!isEmpty(responce.razorpay_signature)) {
      setIsloadingPage(true)

      let params = {
        razorpay_order_id: responce?.razorpay_order_id,
        razorpay_payment_id: responce?.razorpay_payment_id,
        razorpay_signature: responce?.razorpay_signature,

        order_id: subscriptionDetail?.order_id !== undefined ? subscriptionDetail?.order_id : orderDetail?._id,
        payment_order_id: paymentDetail?.id,
        order_history_id: paymentDetail?.order_history_id,
        // plan_id: selectPlans?._id,
        domain: subscriptionDetail?.domain,
        domain_price: subscriptionDetail?.inr_price,
        aimarketing_status: subscriptionDetail?.aimarketing_status,
        total_amount: calculateTotal(),
        plan_type: 'renew',
        billing_details: JSON.stringify({ name: subscriptionDetail?.billing_details?.user_name, email: subscriptionDetail?.billing_details?.email, mobile: subscriptionDetail?.billing_details?.mobile, gstin: subscriptionDetail?.billing_details?.gstin != undefined && !isEmpty(subscriptionDetail?.billing_details?.gstin) ? subscriptionDetail?.billing_details?.gstin : '' })
      }
      // creating a new order
      const { data } = await apiCall("post", apiEndPoint.ORDERPAYMENT, params);
      if (data.status === 200) {
        // successMessage(data.message);
        handleShowConfirmation()
        if (data?.data != undefined && data?.data != '') {
          let arr = data.data
          arr['billing_details'] = JSON.parse(data.data?.billing_details)
          setOrderCompleateData(arr)
        }
      } else {
        navigate("/managetemplate");
        failedMessage(data.message)
      }
      successMessage("Your payment has been completed successfully.");
      setIsloadingPage(false)
    } else {
      failedMessage("Your payment is not completed.")
    }
  }



  async function handlePayment(totalAmount = 0) {
    setIsloading(true)
    let params = { amount: totalAmount }
    // creating a new order
    const { data } = await apiCall("post", apiEndPoint.GENRATEPAYMENTORDERID, params);
    if (data.status !== 200) {
      // failedMessage("Server error. Are you online?");
      failedMessage(data?.message);
      return;
    }
    setPaymentDetail(data.data)
    const { amount, id: order_id, currency } = data.data;
    const options = {
      // key: !isEmpty(userPaymentDetail) ? userPaymentDetail?.key_id : "rzp_test_MdReIabisf3EaD", // Enter the Key ID generated from the Dashboard
      key: "rzp_test_MdReIabisf3EaD", // Enter the Key ID generated from the Dashboard
      amount: amount, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
      currency: currency,
      name: 'Digital india app',
      description: "Test Transaction",
      image: "./assets/images/logo.png",
      order_id: order_id, //This is a sample Order ID. Pass the `id` obtained in the response of createOrder().
      handler: function (response) {
        if (response) {
          orderCompleate(response)
        }
      },
      prefill: {
        name: userData?.user_name,
        email: userData?.email,
        contact: userData?.mobile,
      },
      readonly: {
        name: userData?.user_name,
        email: userData?.email,
        contact: userData?.mobile,
      },
      // callback_url: 'https://api.mydigitalindia.app:3000/api/payment/paymentStatusUpdate',
      // redirect: true,
      user_id: userData?._id,

      notes: {
        address: "Razorpay Corporate Office",
        razorpay_order_id: "",
        razorpay_payment_id: "",
        razorpay_signature: "",

        order_id: subscriptionDetail?.order_id !== undefined ? subscriptionDetail?.order_id : orderDetail?._id,
        payment_order_id: paymentDetail?.id,
        order_history_id: paymentDetail?.order_history_id,
        // plan_id: selectPlans?._id,
        domain: subscriptionDetail?.domain,
        domain_price: subscriptionDetail?.domain_price,
        aimarketing_status: subscriptionDetail?.aimarketing_status,
        total_amount: totalAmount,
        billing_details: JSON.stringify({ name: subscriptionDetail?.billing_details?.user_name, email: subscriptionDetail?.billing_details?.email, mobile: subscriptionDetail?.billing_details?.mobile, gstin: subscriptionDetail?.billing_details?.gstin != undefined && !isEmpty(subscriptionDetail?.billing_details?.gstin) ? subscriptionDetail?.billing_details?.gstin : '' }),
        user_id: userData?._id,
        payment_type: "renew"
      },
      theme: {
        color: "#3399cc",
      },
    };
    setIsloading(false)
    const rzp1 = new Razorpay(options);
    rzp1.open();
  }

  return (
    <Fragment>
      {isloadingPage &&
        <div style={{ width: '100%', textAlign: 'center', height: '100%', backgroundColor: '#0c0c0c99', position: 'absolute', zIndex: 99 }}>
          <Spinner animation="border" style={{ width: '50px', height: '50px', color: 'white', marginTop: '32%' }} role="status" />
        </div>
      }
      <div>
        <div className="services-section mt-5">
          <div className="container text-center">
            <h3 className="animate__animated animate__bounce" style={{ fontFamily: 'quicksand', fontWeight: 600, textAlign: 'center', margin: 'auto' }}>
              {languageData?.renewSubscription}
            </h3>
            <br />
            <p style={{ fontSize: 16, fontWeight: 600, maxWidth: 800, margin: 'auto', color: '#444' }}>
              {languageData?.readyToRenewYourSubscriptionEnsureContinuousService}
            </p>
          </div>
        </div> <br /> <br />
        <Container>
          <div className="p-4" style={{ border: '1px solid #ddd', borderRadius: '12px' }} >
            <Row>
              <Col md={4}>
                <h6>{languageData?.billingDetails} :</h6>
                <Form>
                  <Form.Group className="mb-3">
                    <Form.Label>{languageData?.yourName}</Form.Label>
                    <Form.Control type="text" placeholder="Akhil Nayak"
                      value={subscriptionDetail?.billing_details?.name}
                      onChange={e => handleInputValue('name', e.target.value)} />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>{languageData?.mobileNo}.</Form.Label>
                    <Form.Control type="text" placeholder="9998887776"
                      value={subscriptionDetail?.billing_details?.mobile}
                      onChange={e => handleInputValue('mobile', e.target.value)} />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>{languageData?.email}</Form.Label>
                    <Form.Control type="email" placeholder="akhilnayak@gmail.com"
                      value={subscriptionDetail?.billing_details?.email}
                      onChange={e => handleInputValue('email', e.target.value)} />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>{languageData?.gstin} ({languageData?.optional})</Form.Label>
                    <Form.Control type="text" placeholder="GSTIN Number" value={subscriptionDetail?.billing_details?.gstin} onChange={e => handleInputValue('gstin', e.target.value)} />
                  </Form.Group>

                  {/* AI Marketing Checkbox with Price and Description */}
                  <Form.Group className="mb-3">
                    <div className="d-flex justify-content-between align-items-center">
                      <Form.Check
                        type="checkbox"
                        label="AI Marketing"
                        checked={Boolean(subscriptionDetail?.aimarketing_status)}
                        // onChange={() => setAiMarketing(!aiMarketing)}
                        onChange={() => setSubscriptionDetail({ ...subscriptionDetail, aimarketing_status: !Boolean(subscriptionDetail?.aimarketing_status) })}
                      />
                      <span style={{ fontSize: 13 }}>{languageData?.rs} {aiMarketingPrice}/{languageData?.day}</span>
                    </div>
                    <Form.Text className="text-muted" style={{ fontSize: '0.85rem', display: 'block', marginTop: '5px' }}>
                      {languageData?.getCuttingEdgeAIDrivenMarketingDesigned}
                    </Form.Text>
                  </Form.Group>
                </Form>
              </Col>
              <Col md={1}></Col>
              <Col md={7}>
                <h6>{languageData?.selectedYourDomain} :</h6>
                <InputGroup className="mb-3">
                  <Form.Control
                    placeholder="Akhilnayak.com"
                    value={subscriptionDetail?.domain}
                    readOnly
                  />
                  {!isEmpty(subscriptionDetail?.domain) &&
                    <InputGroup.Text><Image
                      src='assets/images/icon/Checkmark.png'
                      style={{ cursor: 'pointer', width: '25px' }} // Add pointer cursor for clickable effect
                    /></InputGroup.Text>
                  }
                  {/* <InputGroup.Text>
                  <i className="bi bi-check-circle-fill" style={{ color: 'green' }}></i>
                </InputGroup.Text> */}
                </InputGroup>

                {isPremium && (
                  <Alert variant="success" style={{ padding: '0.5rem', fontSize: '0.85rem' }}>
                    {languageData?.youHaveSelectedPremiumDomain} {subscriptionDetail?.domain_price} extra.
                  </Alert>
                )}

                <h5 className="mt-4">{languageData?.summary} :</h5>
                <div style={{ paddingTop: '10px' }}>
                  <Row className="mb-2">
                    <Col>{languageData?.basePrice} ({languageData?.yearly}):</Col>
                    <Col className="text-end">{languageData?.rs} {basePrice} x 365 {languageData?.days}</Col>
                  </Row>
                  <Row className="mb-2" style={{ borderBottom: '1px solid #ff671f', paddingBottom: 10 }}>
                    <Col>{languageData?.premiumDomain} :</Col>
                    <Col className="text-end">{languageData?.rs} {subscriptionDetail?.domain_price > 750 ? subscriptionDetail?.domain_price : 0}</Col>
                  </Row>
                  <Row className="mb-2">
                    <Col>{languageData?.addOn}</Col>
                  </Row>
                  <Row className="mb-2" style={{ borderBottom: '1px solid #ff671f', paddingBottom: 10 }}>
                    <Col className='text-muted'>{languageData?.aiMarketing}</Col>
                    <Col className="text-end">{Boolean(subscriptionDetail?.aimarketing_status) ? `${languageData?.rs} ${aiMarketingPrice} x 365 ${languageData?.days}` : '-'}</Col>
                  </Row> <br />
                  <Row>
                    <Col><strong>{languageData?.total}</strong></Col>
                    <Col className="text-end"><strong>{languageData?.rs} {calculateTotal()}</strong></Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </div> <br />
          <div style={{ marginBottom: '1rem' }}>
            <Button
              style={{ borderRadius: 50, width: 'fit-content', fontSize: 14, background: '#ff966a', color: '#000', fontWeight: 500 }}
              size='lg' onClick={handleCloseRenew}>
              {languageData?.back}
            </Button>
            <Button
              style={{ marginLeft: 20, borderRadius: 50, width: 'fit-content', fontSize: 14, background: '#ff966a', color: '#000', fontWeight: 500 }}
              size='lg'
              onClick={() => handlePayment(calculateTotal())}
            // onClick={handleShowConfirmation}
            >
              {languageData?.checkout}
            </Button>
          </div>

        </Container>
      </div>
    </Fragment >
  );
}

export default RenewSubscription;